var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.8315 14 14 10.8315 14 7C14 3.16152 10.8315 0 6.99302 0C3.16152 0 0 3.16152 0 7C0 10.8315 3.16849 14 7 14ZM7 8.27717C6.72084 8.27717 6.55334 8.10967 6.55334 7.80957L6.47657 3.999C6.46959 3.70588 6.68594 3.48953 6.99302 3.48953C7.30708 3.48953 7.52343 3.70588 7.52343 4.00598L7.43968 7.80957C7.4327 8.10967 7.27218 8.27717 7 8.27717ZM7 10.4895C6.64407 10.4895 6.33699 10.1964 6.33699 9.84048C6.33699 9.49153 6.63709 9.19841 7 9.19841C7.36291 9.19841 7.66999 9.48455 7.66999 9.84048C7.66999 10.1964 7.36291 10.4895 7 10.4895Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.c0efc89138149c67abb945b67a6751b0.svg";
export { ForwardRef as ReactComponent };